import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { motion, easeOut, AnimatePresence } from "framer-motion";
import Classes from "./SectionA.module.css";
import 'react-lazy-load-image-component/src/effects/blur.css';
import Navbar from '../../../Home/Components/Navbar/Navbar';
import { lightFromCorner } from '../../../../../utils/motionVariants';
import StoreSelectionPopup from '../../../../GlobalComp/Footer/StoreSelectionPopup';

const IOS_APP_LINK =
  'https://apps.apple.com/us/app/fuelclubs/id6753362541';
const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.devzona.fuelclubs';

function SectionA() {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280);
  const [showStorePopup, setShowStorePopup] = useState(false);

  const navigate = useNavigate();

  const navigateToSignup = () => {
    navigate('/signup');
  };

  const isMobile = width < 768; // tweak breakpoint if you like (e.g., 640)

  const handleStoreSelect = (platform) => {
    const url = platform === 'ios' ? IOS_APP_LINK : ANDROID_APP_LINK;
    window.open(url, '_blank');
  };

  return (
    <>
      <section id='home' className={Classes.home} >
        <div className={Classes.customBox}>
          <Navbar />
          <div className={Classes.content} >
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: .2, ease: easeOut, delay: 0.2 }}
            >
              <h1 className={Classes.Txt1} >
                See What Our <br /> <span> Customers </span> Are Saying
              </h1>
            </motion.div>

            {/* 
          <motion.div
            initial={{ opacity: 0, y: 150 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: .4, ease: easeOut, delay: 1.5 }}
          >
            <h5 className={Classes.Txt2} >
              Convenient, reliable fuel delivery so you never have to stop for gas again
            </h5>
          </motion.div> */}

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: .2, ease: easeOut, delay: 0.3 }}
              whileTap={{ scale: 0.90 }}
              className={Classes.home_btns_con}
            >
              <div className={Classes.home_btns}>
                {!isMobile && (
                  <motion.div whileTap={{ scale: 0.97 }} whileHover={{ scale: 1.03 }}>
                    <button
                      className={`${Classes.whiteBtn} ${Classes.coloredBtn}`}
                      onClick={navigateToSignup}
                    >
                      <h5>Get started on web</h5>
                    </button>
                  </motion.div>
                )}

                <motion.div whileTap={{ scale: 0.97 }} whileHover={{ scale: 1.03 }}>
                  <button
                    className={Classes.whiteBtn}
                    onClick={() => setShowStorePopup(true)}
                  >
                    <h5>Get started on mobile</h5>
                  </button>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* <motion.div
          className={Classes.demoImageContainer}
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: easeOut, delay: 2 }}
        >
          <div className={Classes.demoImageWrap}>
            <LazyLoadImage
              src="/assets/images/demo-image.webp"
              alt="demo image"
              className={Classes.demoImage}
              loading="eager"
              decoding="async"
              draggable={false}
            />
          </div>
        </motion.div> */}

        <motion.div
          className={Classes.gradientBackground}
        >
          <motion.img
            src='/assets/images/ellipse-left.webp'
            draggable={false}
            loading='lazy'
            decoding="async"
            className={Classes.lightLeft}
            {...lightFromCorner('left', 0.1)}
          />

          <motion.img
            src='/assets/images/ellipse-right.webp'
            draggable={false}
            loading='lazy'
            decoding="async"
            className={Classes.lightRight}
            {...lightFromCorner('right', 0.1)}
          />
        </motion.div>
      </section>

      {/* Reusable Store Selection Popup */}
      <StoreSelectionPopup
        open={showStorePopup}
        onClose={() => setShowStorePopup(false)}
        onSelect={handleStoreSelect}
      />
    </>
  );
}

export default SectionA;
